import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "../style.css";

export const NavBar = () => {
  return (
    <Navbar
      expand="lg"
      className="bg-body-tertiary"
      style={{ position: "absolute", width: "100%", zIndex: 1929 }}
    >
      <Container>
        <Navbar.Brand href="/hotel" className="mr-auto">
          <img
            src={require("./hotel-logo.png")}
            width="105"
            height="105"
            className="d-inline-block align-top"
            alt="demo bank logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav
            className="mx-auto"
            style={{
              fontSize: "20px",
              textTransform: "uppercase",
            }}
          >
            <Nav.Link
              href="/hotel"
              className="mx-2"
              style={{ margin: "0 10px", color: "white" }}
            >
              Home
            </Nav.Link>
            <Nav.Link
              href="/hotel"
              className="mx-2"
              style={{ margin: "0 10px", color: "white" }}
            >
              Rooms
            </Nav.Link>
            <Nav.Link
              href="/hotel"
              className="mx-2"
              style={{ margin: "0 10px", color: "white" }}
            >
              About Us
            </Nav.Link>
            {/*<span style={{color: "white"}}>< /span>*/}
            <Nav.Link
              href="/hotel/mybookings"
              className="mx-2"
              style={{ margin: "0 10px", color: "white" }}
            >
              My Bookings
            </Nav.Link>
            <Nav.Link
              href="/hotel"
              className="mx-2"
              style={{ margin: "0 10px", color: "white" }}
            >
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
